import { useState } from "react";
import { useTranslation } from "react-i18next";

import UnlistedIntelligenceModal from "../../../../ebayListings/unlistedTable/UnlistedIntelligenceModal";
import { EstimateResults } from "../../../InitialPriceEstimateCard";
import { IInitialPriceEstimate, IInitialPriceEstimateCategory } from "../../../../../models/InitialPriceEstimate";
import { SectionCard } from "../Pill";

/**
 * The initial price estimate behind the parts figure on the call screen: the same category table and
 * View matches as the lead page, so an agent can see what the estimate is made of while talking.
 */
export default function PartsEstimateBreakdown({
  estimate,
  showRejected,
  onClose,
}: {
  estimate: IInitialPriceEstimate;
  showRejected: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation("leads");
  const [viewing, setViewing] = useState<IInitialPriceEstimateCategory | null>(null);

  return (
    <SectionCard
      title={t("Initial price estimate")}
      right={
        <button type="button" onClick={onClose} className="text-xs font-medium text-primary-700 underline hover:text-primary-800">
          {t("Hide breakdown")}
        </button>
      }
    >
      <div className="px-4 py-4 sm:px-5">
        <EstimateResults estimate={estimate} onView={setViewing} />
      </div>

      <UnlistedIntelligenceModal
        open={!!viewing}
        setOpen={(open) => {
          const next = typeof open === "function" ? open(!!viewing) : open;
          if (!next) setViewing(null);
        }}
        results={viewing?.results ?? null}
        loading={false}
        title={`${viewing?.categoryName ?? ""} — matching listings`}
        searchTerm={viewing?.searchTerm}
        showExcluded={showRejected}
      />
    </SectionCard>
  );
}
